<template>
  <div>
    <v-app>
    <my-asidebar v-bind:active-tab="'authRole'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">authRole</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>authRole</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-item p-3">

            <v-data-table
                :headers="headers"
                :items="authRoleList"
                :items-per-page="50"
                class="elevation-1">
              <template v-slot:top>
                <v-toolbar
                    flat>
                  <v-toolbar-title>authRoles</v-toolbar-title>
                  <v-divider
                      class="mx-4"
                      inset
                      vertical
                  ></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog
                      v-model="dialog"
                      max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          v-on="on">
                        <i class="la la-plus mr-1"></i>
                        Yeni authRole Yarat
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                                cols="12"
                                sm="6"
                                md="4">
                              <v-text-field
                                  v-model="editedItem.name"
                                  label="authRole Adı"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="close">
                          Cancel
                        </v-btn>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="save">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.name="{ item }">
                <tr>
                  {{ item.name }}
                </tr>
              </template>
              <template v-slot:item.detail="{ item }">
                <tr>
                  <button class="theme-btn theme-btn-small ml-2" @click="goAuthRoleDetail(item)">
                    <i class="la la-plus mr-1"></i>
                  </button>
                </tr>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="row">
<!--                  <div class="table-content mr-2" v-on:click="deleteItem(item)">-->
<!--                    <div class="theme-btn theme-btn-small">-->
<!--                      <i class="la la-trash"></i>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="table-content" @click="editItem(item)">
                    <div class="theme-btn theme-btn-small">
                      <i class="la la-edit"></i>
                    </div>
                  </div>
                </div>
<!--                <v-icon-->
<!--                    small-->
<!--                    class="mr-2"-->
<!--                    @click="editItem(item)"-->
<!--                >-->
<!--                  mdi-pencil-->
<!--                </v-icon>-->
<!--                <v-icon-->
<!--                    small-->
<!--                    @click="deleteItem(item)"-->
<!--                >-->
<!--                  mdi-delete-->
<!--                </v-icon>-->
              </template>
            </v-data-table>

        </div>
      </div>
    </section>
    </v-app>
  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import FormList from "../component/form/FormList";

import messagePopupManager from "../util/messagePopupManager";

export default {
  name: "FormListPage",
  components: {FormList, MyAsidebar, TopBar},
  data () {
    return {
      authRoleList: [],
      dialog: false,
      dialogDelete: false,
      editedItem: {
        name: '',
      },
      defaultItem: {
        name: '',
      },
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'actions',
          value: 'actions',
        },
        {
          text: 'detail',
          value: 'detail',
        }
      ]
    }
  },
  computed:{
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
    // authRoleList:{
    //   get(){
    //     if(this.$store.getters.getauthRoleList === null|| this.$store.getters.getauthRoleList === undefined){
    //       return [];
    //     }
    //     return this.$store.getters.getauthRoleList;
    //   }
    // },
  },
  methods:{
    goAuthRoleDetail(item){
      this.$store.commit("setSelectedRoleName", item.name);
      this.$router.push("/roleright")
    },
    editItem (item) {
      this.editedIndex = this.authRoleList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedItem = Object.assign({}, item)
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteAuthRole",this.editedItem)
        .then(()=>{
          this.loadRoleList();
        })
        .catch(error => {
          messagePopupManager.showError();
        })
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if (this.editedIndex > -1) {
        this.$store.dispatch("updateAuthRole", this.editedItem)
        .then(()=>{
          this.loadRoleList();
        })
        .catch(error => {
          messagePopupManager.showError();
        })

      } else {
        this.$store.dispatch("createAuthRole", this.editedItem)
        .then(()=>{
          this.loadRoleList();
        })
        .catch(error => {
          messagePopupManager.showError();
        })
      }
      this.close()
    },
    loadRoleList(){
      this.$store.dispatch("loadAuthRoleList").then((response) => {
        this.authRoleList = response;
      });
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_AUTH_ROLE_LIST"]) this.$router.push("/");

    this.loadRoleList();
  }
}
</script>

<style scoped>

</style>